import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";
import { DayName } from "uitk-react-date-picker";

export const siteId70971: SiteIdOverrideConfig = {
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
      firstDayOfWeek: DayName.MON,
    },
    form: {
      action: "https://car-rental.expedia.com.vn/{locale}-vn/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    isCarTrawler: true,
    includeGT: false,
    showVendorOptions: false,
    clientID: 312190,
    residenceID: "VN",
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/VN.HPR.012021.pdf",
  },
};
